// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XiLkU","top":"styles_top__1f3nx"};